import React from 'react';
import './DataGroups.css'
import DataGroupsTable from './DataGroupsTable'
import { FusePageSimple } from '@fuse';
import { withStyles } from '@material-ui/core/styles';
import { Modal } from 'react-bootstrap';
import axiosInstance from "../common/AxiosInstace";
import history from "../../../history";
import EndpointsGetter from '../common/EndpointsGetter';
import axiosIntervalInstance from '../common/AxiosIntervalInstance';
import { connect } from 'react-redux';
import { setUserData } from '../../../store/actions/userActions';
import { getUserData } from '../../../store/selectors';

const styles = theme => ({
    layoutRoot: {}
});

class DataGroups extends React.Component {

    constructor(props) {
        super(props);
    }

    state = {
        data: {},
        show: false,
        modalMessage: '',
        isUserInputsValid: true,
        errorString: '',
        shouldGetAllGroups: false,
        clonedGroupName: null,
        lastQueryFilter: null
    };

    componentDidMount() {
        let accessToken = localStorage.getItem("access_token");
        if (accessToken === null || typeof accessToken === "undefined") {
            history.push('/login');
        } else {
            // let user = localStorage.getItem('user');
            // this.props.setUserData(JSON.parse(user));
            if (this.props.history.location.message != null && typeof this.props.history.location.message != 'undefined') {
                let oldState = { ...this.state };
                oldState.modalMessage = this.props.history.location.message;
                oldState.show = true;
                oldState.clonedGroupName = this.props.history.location.groupName;
                this.setState(oldState);
            }
            this.getAllDataGroups(this.props.history.location.groupName ? {
                pageSize: 10,
                pageNumber: 1,
                sort: { "name": "ASC" },
                filters: { "name": this.props.history.location.groupName }
            } : null, false);

            let interval = setInterval(() => {
                this.getAllDataGroups(this.state.lastQueryFilter, true);
            }, 5000);

            this.setState({
                liveRefreshInterval: interval
            });

            this.props.history.location.message = null;
            this.props.history.location.groupName = null;
        }
    }

    componentWillUnmount() {
        let deleteDataModal = document.getElementById('deleteDataModal');
        let deleteGroupModal = document.getElementById('deleteGroupModal');
        if (document.body.contains(deleteDataModal)) {
            deleteDataModal.remove();
        }
        if (document.body.contains(deleteGroupModal)) {
            deleteGroupModal.remove();
        }
        clearInterval(this.state.liveRefreshInterval);
    }

    getDefaultFilter() {
        return {
            pageSize: 10,
            pageNumber: 1,
            sort: {
                "name": "ASC"
            },
            filters: null
        }
    }

    getAllDataGroups(pageAndSortAndFilter, isIntervalCall) {
        if (pageAndSortAndFilter) {
            this.setState({
                lastQueryFilter: pageAndSortAndFilter
            })
        } else {
            this.setState({
                lastQueryFilter: this.getDefaultFilter()
            })
        }
        let instanceToUse = isIntervalCall ? axiosIntervalInstance : axiosInstance;
        let accessToken = localStorage.getItem("access_token");
        instanceToUse.post(EndpointsGetter.getAllGroupsEndpoint(), pageAndSortAndFilter ? pageAndSortAndFilter : this.getDefaultFilter(), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                let oldState = { ...this.state };
                oldState.data = response.data;
                this.setState(oldState);
            })
            .catch(error => {
                this.getError(error);
            });
    }

    showMessage(params) {
        let oldState = { ...this.state };
        oldState.modalMessage = params.message;
        oldState.show = true;
        oldState.shouldGetAllGroups = params.shouldGetAllGroups;
        this.setState(oldState);
    }

    getError(error) {
        let errorString = '';
        if (error.code === 'ECONNABORTED') {
            errorString = "API Request timed out. Please try again after few seconds";
        } else if (error.response.status === 500) {
            errorString = "Operation was unsuccessful. Please try again after few seconds";
        } else if (error.response.status === 400) {
            errorString = error.response.data &&
                error.response.data.errors &&
                error.response.data.errors[0] ? error.response.data.errors[0] : "Bad request. Please try again after few seconds."
        }
        else if (error.response.status === 401) {
            // errorString = "Unauthorized";
        } else {
            errorString = error.response.data.message ? error.response.data.message : error.response.data.error_description;
            if (error.response.status === 400 && errorString.includes("Invalid refresh token")) {
                history.push('/login');
            }
        }
        let oldState = { ...this.state };
        oldState.isUserInputsValid = false;
        oldState.errorString = errorString;
        oldState.data = {};
        this.setState(oldState);
        setTimeout(() => {
            let oldState = { ...this.state };
            oldState.isUserInputsValid = true;
            oldState.errorString = '';
            this.setState(oldState);
        }, 5000);
    }

    handleHideModal() {
        let oldState = { ...this.state };
        oldState.show = false;
        if (this.state.shouldGetAllGroups) {
            oldState.shouldGetAllGroups = false;
            this.getAllDataGroups(null, false);
        }
        this.setState(oldState);
    }

    render() {
        const { classes, user } = this.props;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className='header-container'>
                        <div>
                            <h3 className='header-title'>Data Groups</h3>
                        </div>
                    </div>
                }
                content={
                    <div className='management-screen-layout'>
                        {!this.state.isUserInputsValid ?
                            <div className="screen-layout">
                                <label className="text-area-label"
                                    style={{ color: 'red' }}>{this.state.errorString}</label>
                            </div>
                            : null
                        }
                        <Modal
                            show={this.state.show}
                            onHide={this.handleHide}
                            container={this}
                            aria-labelledby="contained-modal-title"
                        >
                            <Modal.Header>
                                <Modal.Title id="contained-modal-title">
                                    Message
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {this.state.modalMessage}
                            </Modal.Body>
                            <Modal.Footer>
                                <button type="button" className="btn btn-info" onClick={(e) => this.handleHideModal()}>
                                    OK
                                </button>
                            </Modal.Footer>
                        </Modal>
                        <DataGroupsTable dataList={this.state.data}
                            clonedGroupName={this.state.clonedGroupName ? this.state.clonedGroupName : null}
                            errorCallback={this.getError.bind(this)}
                            messageCallback={this.showMessage.bind(this)}
                            getAllGroupsCallback={this.getAllDataGroups.bind(this)}
                            user={user} />
                    </div>
                }
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const userData = getUserData(state).user;
    return {
        user: userData
    };
};

const mapDispatchToProps = {
    setUserData
};

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(DataGroups));



// WEBPACK FOOTER //
// ./src/main/content/data-groups/DataGroups.js